import React, { useState, useEffect, useCallback } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, TextField, FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import api from '../../../api/api';
import Loading from '../../../components/loading';
import ErrorMessage from '../../../components/errorMessage';
import { useParams } from 'react-router-dom';

export default function TreatmentsModal({ open, onCloseTreatmentModal, onTreatmentSaved }) {

    const { patientId } = useParams();

    const [isLoading, setLoading] = useState(false);
    const [showErrorMessage, setShowErrorMessage] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');

    const [comboBoxDentists, setComboBoxDentists] = useState([]);
    const [selectedDentistId, setSelectedDentistId] = useState('');

    const [description, setDescription] = useState('');
    const [insurance, setInsurance] = useState('');

    const getComboBoxDentists = useCallback(() => {
        api.get("/dentists/combobox", {
            headers: {
                Authorization: sessionStorage.getItem('token')
            }
        }).then((returnFromApi) => {
            setComboBoxDentists(returnFromApi.data);
        }).catch((returnFromApi) => {
                setLoading(false);
                console.error("ops! ocorreu um erro" + returnFromApi);
                setErrorMessage(returnFromApi.response.data);
        });
    }, []);

    useEffect(() => {
        const dentistIdFromUser = sessionStorage.getItem('dentistIdFromUser');
        if (dentistIdFromUser && dentistIdFromUser !== 'null' && dentistIdFromUser !== 'undefined') {
            setSelectedDentistId(dentistIdFromUser);
        }
        
        getComboBoxDentists();
    }, [open, getComboBoxDentists]);


    const saveTreatment = (event) => {
        event.preventDefault();

        if (!insurance || !description.trim() || !selectedDentistId) {
            setShowErrorMessage(true);
            setErrorMessage("Todos os campos são obrigatórios!");
            return;
        }

        const treatment = {
            pacienteId: patientId,
            descricao: description,
            convenio: insurance,
            dentistaId: selectedDentistId,
        };

        setLoading(true);
        api.post("/treatments", treatment, {
            headers: {
                Authorization: sessionStorage.getItem('token')
            }
        }).then((returnFromApi) => {
            onTreatmentSaved(returnFromApi);
            cleanFields();
            setLoading(false);
        }).catch((returnFromApi) => {
            onTreatmentSaved(returnFromApi);
            console.error("Erro ao salvar tratamento:", returnFromApi);
            setLoading(false);
        });
    };

    function cleanFields() {
        setSelectedDentistId('');
        setDescription('');
        setInsurance('');
    }

    return (
        <Dialog open={open} onClose={onCloseTreatmentModal} maxWidth="sm" fullWidth>

            <Loading isToHidden={isLoading === false} />
            {showErrorMessage && <ErrorMessage message={errorMessage} show={showErrorMessage} setShow={setShowErrorMessage} />}

            <DialogTitle>
                Novo Tratamento
            </DialogTitle>
            <DialogContent dividers>
                <form id="new-treatment-form" onSubmit={saveTreatment}>
                    <Grid container spacing={3} sx={{ mt: 2 }}>
                        <Grid item size={12} >
                            <TextField fullWidth
                                label="Descrição do Tratamento"
                                value={description}
                                onChange={e => setDescription(e.target.value)}
                                variant="outlined"
                            />
                        </Grid>

                        <Grid item size={6}>
                            <FormControl fullWidth>
                                <InputLabel id="convenio-label">Convênio</InputLabel>
                                <Select
                                    labelId="convenio-label"
                                    value={insurance}
                                    label="Convênio"
                                    onChange={e => setInsurance(e.target.value)}
                                >
                                    <MenuItem value=""><em>Selecione</em></MenuItem>
                                    <MenuItem value="PARTICULAR">Particular</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>

                        <Grid item size={6}>
                            <FormControl fullWidth>
                                <InputLabel id="dentista-label">Dentista</InputLabel>
                                <Select fullWidth
                                    labelId="dentist-combobox-label"
                                    id="dentist-combobox"
                                    value={selectedDentistId}
                                    label="Dentista"
                                    onChange={(e) => setSelectedDentistId(e.target.value)}>

                                    {comboBoxDentists.map((dentist) => (
                                        <MenuItem value={dentist.id}>{dentist.nome}</MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>
                    </Grid>
                </form>
            </DialogContent>
            <DialogActions>
                <Button onClick={onCloseTreatmentModal}>Cancelar</Button>
                <Button
                    type="submit"
                    form="new-treatment-form"
                    variant="contained"
                >
                    Salvar
                </Button>
            </DialogActions>
        </Dialog>
    );
}